var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "16",
        height: "17",
        viewBox: "0 0 16 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("circle", {
        attrs: { cx: "1.5", cy: "2.46411", r: "1.5", fill: "white" }
      }),
      _vm._v(" "),
      _c("ellipse", {
        attrs: {
          cx: "7.7002",
          cy: "2.46411",
          rx: "1.5",
          ry: "1.5",
          fill: "white"
        }
      }),
      _vm._v(" "),
      _c("ellipse", {
        attrs: {
          cx: "13.8999",
          cy: "2.46411",
          rx: "1.5",
          ry: "1.5",
          fill: "white"
        }
      }),
      _vm._v(" "),
      _c("ellipse", {
        attrs: { cx: "1.5", cy: "8.66431", rx: "1.5", ry: "1.5", fill: "white" }
      }),
      _vm._v(" "),
      _c("circle", {
        attrs: { cx: "7.7002", cy: "8.66431", r: "1.5", fill: "white" }
      }),
      _vm._v(" "),
      _c("ellipse", {
        attrs: {
          cx: "13.8999",
          cy: "8.66431",
          rx: "1.5",
          ry: "1.5",
          fill: "white"
        }
      }),
      _vm._v(" "),
      _c("ellipse", {
        attrs: { cx: "1.5", cy: "14.864", rx: "1.5", ry: "1.5", fill: "white" }
      }),
      _vm._v(" "),
      _c("ellipse", {
        attrs: {
          cx: "7.7002",
          cy: "14.864",
          rx: "1.5",
          ry: "1.5",
          fill: "white"
        }
      }),
      _vm._v(" "),
      _c("circle", {
        attrs: { cx: "13.8999", cy: "14.864", r: "1.5", fill: "white" }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }